import Store from 'redux/store';
import {
  FETCH_STORES,
  FETCH_STORES_FAIL,
  FETCH_STORES_SUCCESS,
} from 'redux/Reducers/Stores/StoresReducer';

import { cloudloyalty } from '../clients';

const FetchLoadStores = async (User, finallyCallback = () => {}, {}) => {
  Store.dispatch({ type: FETCH_STORES });
  cloudloyalty(User)
    .get(
      `/v1/stores/getStoresAllStatus?catalogId=${User.profile['custom:catalog_id']}`
    )
    .then((response) => {
      Store.dispatch({
        type: FETCH_STORES_SUCCESS,
        payload: {
          ...response,
        },
      });
    })
    .catch((e) => {
      Store.dispatch({
        type: FETCH_STORES_FAIL,
        error: e,
      });
    })
    .finally(() => {
      finallyCallback();
    });
};

export default FetchLoadStores;
